export const FreteCaminhoneiroSubstatusEnum = {
  NAO_APTO: 'Não Apto',
  APTO: 'Apto',
  CHAMADO: 'Chamado',
  TRIADO: 'Triado',
};
